// Vanilla Lazyload
import LazyLoad from "vanilla-lazyload";

// Vanilla lazy init
const lazyLoadInstance = new LazyLoad({
	// use_native:true
});

const header = document.querySelector('.js-site-header');

// Show/hide header on scroll
(function () {

	if (!header) return;

	let lastScroll = window.scrollY || document.documentElement.scrollTop;

	// Helper function to get the scroll direction
	const getScrollDirection = (currentScroll, lastScroll) => {
		return currentScroll > lastScroll ? 'down' : 'up';
	}

	// Update header style depending on scroll position
	const updateHeader = () => {
		const currentScroll = document.documentElement.scrollTop;
		const scrollDirection = getScrollDirection(currentScroll, lastScroll);

		if (currentScroll > 100) {
			header.classList.add('site-header--scrolled');
			// Make outline ctas solid
			header.querySelectorAll('.js-header-outline-btn').forEach(btn => btn.classList.remove('btn--outline'));
		} else {
			header.classList.remove('site-header--scrolled');
			// Make outline ctas outline again
			header.querySelectorAll('.js-header-outline-btn').forEach(btn => btn.classList.add('btn--outline'));
		}

		lastScroll = currentScroll <= 0 ? 0 : currentScroll; // For Mobile or negative scrolling
	}

	// Call update header once to apply the correct classes if header is already scrolled when loading page
	updateHeader();

	// Call udpate header on scroll
	window.addEventListener('scroll', updateHeader, false);

})();

// Hamburger Menu JS
(function () {
	const mobileNavToggleButton = document.querySelector('.js-mob-navigation-toggle');

	if (!header || !mobileNavToggleButton) return;

	// Mob navigation toggle
	mobileNavToggleButton.addEventListener('click', e => {
		e.preventDefault();

		const isOpen = document.body.classList.toggle('has-mobile-menu-open');
		header.classList.toggle('has-mobile-menu-open', isOpen);
		mobileNavToggleButton.setAttribute('aria-expanded', isOpen.toString());
	});
})();

// Mega Menus JS
(function () {

	if (!header) return;

	const menuItemsWithMegaMenu = document.querySelectorAll('.js-menu-item-has-mega-menu');
	// Loop through all menu items that have mega menus --  Add animations & click events
	menuItemsWithMegaMenu.forEach(menuItem => {

		// Add click event to all menu items that have mega menus
		menuItem.addEventListener('click', (e) => {

			if (e.target.closest('.js-mega-menu-wrapper')) return; // ignore clicks from inside the mega menu
			e.preventDefault(); // prevent page redirect (if it's menu item is linked to a page)

			const isOpened = menuItem.classList.contains('is-opened');
			const megaMenu = menuItem.querySelector('.js-mega-menu-wrapper');

			if (isMobile()) {
				menuItem.classList.toggle('is-opened');
				// header.classList.toggle('has-mega-menu-open');

			} else {
				if (isOpened) {
					// Close all opened mega menus (including the current one)
					closeAllMegaMenus();
				} else {
					// Close all opened mega menus
					closeAllMegaMenus();
					// Open current mega menu
					menuItem.classList.add('is-opened');
					header.classList.add('has-mega-menu-open');
					document.body.classList.add('has-mega-menu-open'); // Body class -- showing the backdrop
				}

			}

		});
	});


	// Close mega menus when clicking outside
	document.addEventListener('click', function (e) {
		if (isMobile()) return; // Apply this only on desktop

		if (!e.target.closest('.js-mega-menu-wrapper') && !e.target.closest('.js-menu-item-has-mega-menu > a')) {
			closeAllMegaMenus();
		}
	}, false);

})();

// Mobile sub-menus JS
(function () {

	const mobMenuItemsWithSubMenu = document.querySelectorAll('.js-site-header li.menu-item-has-children');
	mobMenuItemsWithSubMenu.forEach(menuItem => {

		menuItem.addEventListener('click', (e) => {
			if (!isMobile()) return; // Only run on mobile
			e.preventDefault();

			menuItem.classList.toggle('is-opened');
		});

		// Don't trigger dropdown toggle when clicking on menu item children (prevent event bubbling)
		menuItem.querySelector('.sub-menu-wrapper')?.addEventListener('click', e => { e.stopPropagation() });
	});

})();

// Glightbox JS
(function () {
	document.addEventListener('DOMContentLoaded', () => {
		import('glightbox').then(({ default: GLightbox }) => {

			// Glightbox init
			const lightbox = GLightbox({
				videosWidth: '1200px',
				openEffect: 'fade',
				closeEffect: 'none',
			});

		}).catch(error => {
			console.error('Error loading GLightbox:', error);
		});
	});
})();


// Lazy load scripts
(function () {

	const options = {
		root: null,
		rootMargin: '0px 0px 500px 0px', // Start loading script 500px before it gets visible
		// threshold: 0.1
	};

	document.querySelectorAll(`script[data-src][data-selector]`).forEach(script => {

		const selector = script.getAttribute('data-selector');
		const src = script.getAttribute("data-src")
		const elements = document.querySelectorAll(selector);

		if (!elements.length || !src) return;

		const observer = new IntersectionObserver((entries, observer) => {
			entries.forEach(entry => {
				const block = entry.target;

				if (entry.isIntersecting) {
					// Skip script if already has 'src'
					if (!script.scrc) {
						script.setAttribute("src", script.getAttribute("data-src"));
						observer.unobserve(block);
					}
				}
			});
		}, options);

		elements.forEach(element => observer.observe(element));

	});

})();

// Show elements on scroll JS
(function () {
	window.addEventListener('load', function () {

		const elementsToAnimate = document.querySelectorAll('.js-animate-on-scroll');

		if (!elementsToAnimate.length) return;

		const options = {
			root: null,
			// rootMargin: '0px 0px 0px 0px',
			threshold: 0
		};

		const observer = new IntersectionObserver((entries, observer) => {
			entries.forEach(entry => {
				if (entry.isIntersecting) {
					entry.target.classList.add('is-visible');
					observer.unobserve(entry.target); // Stop observing once visible
				}
			});

		}, options);

		elementsToAnimate.forEach(element => {
			observer.observe(element);
		});

	});


})();


// Disable scrollRestoration
if (history.scrollRestoration) {
	const scrollRestoration = page_info.disable_scroll_restoration ? "manual" : "auto";
	history.scrollRestoration = "auto";
}

// Tooltips JS
(function () {
	const tooltips = document.querySelectorAll('.js-tooltip');

	// Tooltip click events
	document.addEventListener('click', function (e) {

		if (e.target.closest('.js-tooltip')) {

			const tooltip = e.target.closest('.js-tooltip');

			const tooltipToggle = tooltip.querySelector('.js-tooltip-toggle');
			const tooltipContent = tooltip.querySelector('.js-tooltip-content');

			if (!tooltipToggle || !tooltipContent) return;

			if (e.target === tooltipToggle) {
				// Hide tooltip if it's already visible
				if (tooltipContent.classList.contains('show')) {
					tooltip.classList.remove('is-active');
					tooltipContent.classList.remove('show');
					return;
				}

				hideTooltips(); // Hide other tooltips
				tooltipContent.classList.add('show'); // Show current tooltip
				tooltip.classList.add('is-active');
			}

		} else {
			hideTooltips();
		}

	}, false);

	// Initially position tooltip
	positionTooltip();

	// Update tooltip position on window resize
	window.addEventListener('resize', () => {
		positionTooltip();
	});

	// Position tooltip -- make sure tooltip never goes out of bounds
	function positionTooltip() {

		// Only run on mobile
		if (!window.matchMedia("(max-width: 767px)").matches) return;

		tooltips.forEach((tooltip, index) => {

			const viewportWidth = window.innerWidth;

			const tooltipToggle = tooltip.querySelector('.js-tooltip-toggle');
			const tooltipContent = tooltip.querySelector('.js-tooltip-content');
			const tooltipArrow = tooltip.querySelector('.js-tooltip-arrow');

			const toggleRect = tooltipToggle.getBoundingClientRect();

			// Calculate tooltipToggle's position in percentage
			const buttonPositionPercentage = (toggleRect.left + toggleRect.width / 2) / viewportWidth * 100;

			if (buttonPositionPercentage > 80) {
				// tooltipToggle is within 20% of the right edge

				// position tooltip content
				tooltipContent.style.right = '-12px';
				tooltipContent.style.left = 'auto';
				tooltipContent.style.transform = 'none';

				// position tooltip arrow
				tooltipArrow.style.right = '14px';
				tooltipArrow.style.left = 'auto';
				tooltipArrow.style.transform = 'none';
			} else if (buttonPositionPercentage < 20) {
				// tooltipToggle is within 20% of the left edge

				// position tooltip content
				tooltipContent.style.left = '-12px';
				tooltipContent.style.right = 'auto';
				tooltipContent.style.transform = 'none';

				// position tooltip arrow
				tooltipArrow.style.right = 'auto';
				tooltipArrow.style.left = '14px';
				tooltipArrow.style.transform = 'none';

			} else {
				// position tooltip content
				tooltipContent.style.left = '50%';
				tooltipContent.style.right = 'auto';
				tooltipContent.style.transform = 'translateX(-50%)';

				// position tooltip arrow
				tooltipArrow.style.right = 'auto';
				tooltipArrow.style.left = '50%';
				tooltipArrow.style.transform = 'translateX(-50%)';
			}
		});

	}


	// Helper function to hide tooltips
	function hideTooltips() {
		tooltips.forEach((tooltip, index) => {
			const tooltipContent = tooltip.querySelector('.js-tooltip-content');

			tooltip.classList.remove('is-active');
			tooltipContent.classList.remove('show');
		});
	}

})();


// Lazy load HubSpot Forms JS
window.addEventListener('load', () => {

	const forms = document.querySelectorAll('.js-hs-form-wrapper'); // Replace with your form class or selector
	const script = document.getElementById('hs-forms-script');

	if (!script || !forms.length) return;

	const options = {
		root: null,
		rootMargin: '0px 0px 500px 0px', // Start loading script 500px before it gets visible
		// threshold: 0.1
	};


	const loadHubspotScript = () => {
		if (script.getAttribute('src')) return; // Prevent duplicate loads
		script.src = script.dataset.src;

		script.onload = () => {
			// Load Hubspot forms
			forms.forEach((form) => {
				const id = form.getAttribute('id');
				const hsRegion = form.getAttribute('data-region');
				const hsPortalId = form.getAttribute('data-portal-id');
				const hsFormId = form.getAttribute('data-form-id');

				if (id && hsRegion && hsPortalId && hsFormId) {
					// console.log(`Creating form ${hsFormId}`);
					hbspt.forms.create({
						region: hsRegion,
						portalId: hsPortalId,
						formId: hsFormId,
						target: `#${id}`
					});
				}
			});
		};
	};

	const observer = new IntersectionObserver((entries, observer) => {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				loadHubspotScript();
				observer.unobserve(entry.target); // Unobserve after the first load
			}
		});
	});

	forms.forEach((form) => observer.observe(form));
});




// Update scrollbar css variable so we can reliably set 100vw in CSS
(function () {
	const getScrollbarWidth = () => window.innerWidth - document.documentElement.clientWidth;

	const updateScrollbarWidthVariable = () => {
		const scrollbarWidth = getScrollbarWidth();
		// Set a custom property with the value we calculated
		document.documentElement.style.setProperty('--scrollbar', `${scrollbarWidth}px`);
	}

	updateScrollbarWidthVariable();
	window.addEventListener('resize', updateScrollbarWidthVariable);

})();


// Careers page -- scroll to greenhouse widget if it has GET parameter with job id
(function () {

	// Get the current URL
	const url = new URL(window.location.href);

	// Access the search parameters
	const params = new URLSearchParams(url.search);

	if (!params.has('gh_jid')) return;

	const jobsSection = document.getElementById('open-positions');

	if(!jobsSection) return;

	// Calculate the element's position relative to the document
	const targetElementTop = jobsSection.getBoundingClientRect().top + window.scrollY;
	let headerHeight = header.offsetHeight || 100;
	headerHeight = parseInt(headerHeight, 10);

	scrollTo({
		top: targetElementTop - headerHeight,
		behavior: "smooth"
	});
})();


// HELPER FUNCTIONS

// Helper function to return if we are on mobile view
// It checks if the mobile burger menu button is visible
function isMobile() {
	const mobileNavToggleButton = document.querySelector('.js-mob-navigation-toggle');
	if (!mobileNavToggleButton) return;

	return mobileNavToggleButton.offsetWidth > 0 && mobileNavToggleButton.offsetHeight > 0;;
}

// Helper function to loop through all and close all mega menus
function closeAllMegaMenus() {
	const menuItemsWithMegaMenu = document.querySelectorAll('.js-menu-item-has-mega-menu');

	// Loop through all active mega menus and close them
	[...menuItemsWithMegaMenu].filter(item => item.classList.contains('is-opened')).forEach(item => {
		const megaMenu = item.querySelector('.js-mega-menu-wrapper');

		item.classList.remove('is-opened'); // Menu item class
		header.classList.remove('has-mega-menu-open'); // Header class -- custom header styles
		document.body.classList.remove('has-mega-menu-open'); // Body class -- showing the backdrop
	});
}
